import { Component, OnInit, Input } from '@angular/core';
import {Video} from '../../models/video/video';
import * as moment from 'moment';
import {LiveEvent} from '../../models/live-event/live-event';

@Component({
  selector: 'app-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: ['./hero-video.component.scss']
})
export class HeroVideoComponent implements OnInit {
  @Input()
  live: boolean = true;
  @Input()
  title: string = "FEATURED";
  @Input()
  video: LiveEvent;
  formattedStartTime: string;
  constructor() { }

  ngOnInit() {
    const d = new Date(this.video.startTime);
    this.formattedStartTime = moment(d).calendar();
  }

}
